// High is orange, a step between Moderate (warning) and Blocking (danger).
export const SEVERITY_BADGE_VARIANTS = {
    Informational: 'neutral',
    Moderate: 'warning',
    High: 'orange',
    Blocking: 'danger'
};
// D115: Routed, Escalated and Corrected share the violet tone.
export const RESOLUTION_BADGE_VARIANTS = {
    Open: 'neutral',
    Routed: 'violet',
    Accepted: 'success',
    Corrected: 'violet',
    Waived: 'warning',
    Rejected: 'danger',
    Escalated: 'violet',
    Applied: 'success',
    Closed: 'success',
    // An award comparison row settled with nothing written (RI-3b2).
    Acknowledged: 'info'
};
